import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';
import ConstellationIcon from '../components/icons/ConstellationIcon';
import { constellationData } from '../data/constellationData';

// Convert constellationData object to array
const constellations = Object.values(constellationData);

// Element types with Chinese names and colors
const elementTypes = [
  { id: 'all', name: '全部', color: '#9b59b6' },
  { id: 'fire', name: '火象星座', color: '#e74c3c' },
  { id: 'earth', name: '土象星座', color: '#8b4513' },
  { id: 'air', name: '风象星座', color: '#3498db' },
  { id: 'water', name: '水象星座', color: '#2ecc71' },
];

const HomePage = () => {
  const [selectedElement, setSelectedElement] = useState('all');

  // Filter constellations based on selected element
  const filteredConstellations = selectedElement === 'all' 
    ? constellations 
    : constellations.filter(c => c.element === selectedElement);

  return (
    <>
      <title>星座探秘 - 首页</title>
      <meta name="description" content="欢迎来到星座探秘。探索十二星座的奥秘，发现你的星座特点、进行星座配对、每日占卜和查询最新运势。" />
      <div className="home-page">
        <h1>探索你的星座</h1>
        <p>点击下方的星座图标，开始你的探索之旅。</p>
        
        {/* Element filter tabs */}
        <div className="element-filters">
          {elementTypes.map(element => (
            <button
              key={element.id}
              className={`element-tab ${selectedElement === element.id ? 'active' : ''}`}
              onClick={() => setSelectedElement(element.id)}
              style={{ '--element-color': element.color }}
            >
              {element.name}
            </button>
          ))}
        </div>

        <div className="constellation-grid">
          {filteredConstellations.map(c => (
            <Link to={`/constellation/${c.name.toLowerCase()}`} key={c.name} className="constellation-card">
              <ConstellationIcon name={c.name} />
              <h2>{c.chineseName}</h2>
              <p>{c.name}</p>
              <p>{c.date}</p>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default HomePage;
